import { Button, Stack } from "@mui/material";
import { Formik, Form } from "formik";
import * as yup from "yup";
import FolderBuilder from "./FolderBuilder";
import TextInput from "../../common/TextInput";
import { useCreateTemplate } from "../../../hooks/api/useCreateTemplate";
import { TemplateConfig } from "../../../types/template";
import { useNavigate } from "react-router-dom";

interface TemplateFormProps {
  onSuccess?: () => void;
}

const validationSchema = yup.object({
  name: yup.string().required("Nombre obligatorio"),
  config: yup
    .array()
    .of(
      yup.object().shape({
        text: yup.string().required("Nombre de carpeta requerido"),
        description: yup.string(),
        icon: yup.string(),
        color: yup.string(),
        children: yup.array(),
      })
    )
    .min(1, "Debe tener al menos una carpeta")
    .required("Configuración requerida"),
});

interface TemplateFormValues {
  name: string;
  config: TemplateConfig[];
}

const TemplateForm = ({ onSuccess }: TemplateFormProps) => {
  const navigate = useNavigate();
  const { mutate: createTemplate, isPending } = useCreateTemplate();

  const initialValues: TemplateFormValues = {
    name: "",
    config: [
      {
        text: "Nueva Carpeta",
        description: "",
        icon: "folder",
        color: "#808080",
        children: [],
      },
    ],
  };

  const handleSubmit = (values: TemplateFormValues) => {
    createTemplate(values, {
      onSuccess: () => {
        navigate("/dashboard/templates");
        onSuccess?.();
      },
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Stack spacing={3}>
            <TextInput name="name" label="Nombre de la plantilla" fullWidth />

            <FolderBuilder
              config={values.config}
              onChange={(config: TemplateConfig[]) =>
                setFieldValue("config", config)
              }
            />

            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={isPending}
              sx={{ mt: 3 }}
            >
              {isPending ? "Guardando..." : "Guardar Plantilla"}
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default TemplateForm;
